import { KYMW1313Component } from './kymw1313.component';
import { isArray } from 'util';
import { KYMW1313SetPlanPromotionGoodsInfoModel } from './vo/kymw1313-set-plan-promotion-goods-info.model';

/**
 * セット企画検索画面の値を管理するクラス
 *
 * @export KYMW1313Model
 * @class KYMW1313Model
 */
export class KYMW1313Model {

  public kymw1313Component: KYMW1313Component;

  private readonly FLAG_ON: string = '1';

  // プロモーション名称
  public promotionName: string = <string>'';

  // プロモーション区分
  public promotionDiv: string = <string>'';

  // Ｐコード
  public pCode: string = <string>'';

  // セット企画商品名
  public setDelivGoodsName: string = <string>'';

  // 生協
  public coop: string = <string>'';

  // 部門コード
  public classCode: string = <string>'';

  // プロモーション情報
  public promotionInfo: Array<any> = new Array<any>();

  // 受注コード
  public orderCode: string = <string>'';

  /**
   * サーバ取得データを反映する
   *
   * @param promotionGoodsInfo サーバ取得データ
   */
  public updateKYMW1313(promotionGoodsInfo: any): void {

    if (promotionGoodsInfo == null) {
      this.promotionInfo = new Array<any>();
      return;
    }

    this.promotionInfo = new Array<any>();

    if (isArray(promotionGoodsInfo)) {
      for (let i: number = <number>0; i < promotionGoodsInfo.length; i++) {
        this.promotionInfo.push(this.getPromotionGoodsInfoVO(promotionGoodsInfo[i]));
      }
    } else {
      this.promotionInfo.push(this.getPromotionGoodsInfoVO(promotionGoodsInfo));
    }
  }

  /* プロモーション情報一覧を作成 */
  private getPromotionGoodsInfoVO(data: any): KYMW1313SetPlanPromotionGoodsInfoModel {

    const vo: KYMW1313SetPlanPromotionGoodsInfoModel = new KYMW1313SetPlanPromotionGoodsInfoModel();

    // プロモーションＮＯ
    vo.promotionNo = data.PromotionNo;
    // プロモーション名称
    vo.promotionName = data.PromotionName;
    // Ｐコード
    vo.pCode = data.PCode;

    // 商品案内用商品名
    vo.guideGoodsName = data.GuideGoodsName;
    // 商品案内用規格名
    vo.guideStandardName = data.GuideStandardName;

    // 消費税区分
    vo.consumeTaxDiv = data.ConsumeTaxDiv;
    // 消費税率
    vo.consumeTaxRate = data.ConsumeTaxRate;

    // セット企画商品名
    vo.setDelivGoodsName = data.SetDelivGoodsName;
    // セット企画商品名(カナ)
    vo.setDelivGoodsNameKana = data.SetDelivGoodsNameKana;
    // セット企画規格名
    vo.setDelivStandardName = data.SetDelivStandardName;
    // セット企画規格名(カナ)
    vo.setDelivStandardNameKana = data.SetDelivStandardNameKana;

    // セット企画区分
    vo.setPlanDiv = data.SetPlanDiv;
    // セット企画区分名称
    vo.setPlanDivName = data.SetPlanDivName;
    // 単品注文可否区分
    vo.singleOrderFlag = data.SingleOrderFlag;
    // 単品注文可否区分名称
    vo.singleOrderFlagName = data.SingleOrderFlagName;

    // 取扱フラグ（いばらき）
    if (data.HandlingFlgIB === this.FLAG_ON) {
      // 供給価格（税込）
      vo.thisTimeSupplyPriceIB = data.ThisTimeSupplyPriceIB;
      // 仕入価格
      vo.thisTimeCostPriceIB = data.ThisTimeCostPriceIB;
      // プロモーションフラグ（いばらき）
      if (data.PromotionFlgIB === this.FLAG_ON) {
        // 成立数量
        vo.approvedNumIB = data.ApprovedNumIB;
        // 成立価格
        vo.approvedPriceIB = data.ApprovedPriceIB;
      }
      // 配達リード区分
      vo.deliveryLeadTimeTypeIB = data.DeliveryLeadTimeTypeIB;
      // 配達リード区分名称
      vo.deliveryLeadTimeTypeNameIB = data.DeliveryLeadTimeTypeNameIB;
    }

    // 取扱フラグ（とちぎ）
    if (data.HandlingFlgTO === this.FLAG_ON) {
      // 供給価格（税込）
      vo.thisTimeSupplyPriceTO = data.ThisTimeSupplyPriceTO;
      // 仕入価格
      vo.thisTimeCostPriceTO = data.ThisTimeCostPriceTO;
      // プロモーションフラグ（とちぎ）
      if (data.PromotionFlgTO === this.FLAG_ON) {
        // 成立数量
        vo.approvedNumTO = data.ApprovedNumTO;
        // 成立価格
        vo.approvedPriceTO = data.ApprovedPriceTO;
      }
      // 配達リード区分
      vo.deliveryLeadTimeTypeTO = data.DeliveryLeadTimeTypeTO;
      // 配達リード区分名称
      vo.deliveryLeadTimeTypeNameTO = data.DeliveryLeadTimeTypeNameTO;
    }

    // 取扱フラグ（ぐんま）
    if (data.HandlingFlgGU === this.FLAG_ON) {
      // 供給価格（税込）
      vo.thisTimeSupplyPriceGU = data.ThisTimeSupplyPriceGU;
      // 仕入価格
      vo.thisTimeCostPriceGU = data.ThisTimeCostPriceGU;
      // プロモーションフラグ（ぐんま）
      if (data.PromotionFlgGU === this.FLAG_ON) {
        // 成立数量
        vo.approvedNumGU = data.ApprovedNumGU;
        // 成立価格
        vo.approvedPriceGU = data.ApprovedPriceGU;
      }
      // 配達リード区分
      vo.deliveryLeadTimeTypeGU = data.DeliveryLeadTimeTypeGU;
      // 配達リード区分名称
      vo.deliveryLeadTimeTypeNameGU = data.DeliveryLeadTimeTypeNameGU;
    }

    // 取扱フラグ（ちば）
    if (data.HandlingFlgTI === this.FLAG_ON) {
      // 供給価格（税込）
      vo.thisTimeSupplyPriceTI = data.ThisTimeSupplyPriceTI;
      // 仕入価格
      vo.thisTimeCostPriceTI = data.ThisTimeCostPriceTI;
      // プロモーションフラグ（ちば）
      if (data.PromotionFlgTI === this.FLAG_ON) {
        // 成立数量
        vo.approvedNumTI = data.ApprovedNumTI;
        // 成立価格
        vo.approvedPriceTI = data.ApprovedPriceTI;
      }
      // 配達リード区分
      vo.deliveryLeadTimeTypeTI = data.DeliveryLeadTimeTypeTI;
      // 配達リード区分名称
      vo.deliveryLeadTimeTypeNameTI = data.DeliveryLeadTimeTypeNameTI;
    }

    // 取扱フラグ（さいたま）
    if (data.HandlingFlgSA === this.FLAG_ON) {
      // 供給価格（税込）
      vo.thisTimeSupplyPriceSA = data.ThisTimeSupplyPriceSA;
      // 仕入価格
      vo.thisTimeCostPriceSA = data.ThisTimeCostPriceSA;
      // プロモーションフラグ（さいたま）
      if (data.PromotionFlgSA === this.FLAG_ON) {
        // 成立数量
        vo.approvedNumSA = data.ApprovedNumSA;
        // 成立価格
        vo.approvedPriceSA = data.ApprovedPriceSA;
      }
      // 配達リード区分
      vo.deliveryLeadTimeTypeSA = data.DeliveryLeadTimeTypeSA;
      // 配達リード区分名称
      vo.deliveryLeadTimeTypeNameSA = data.DeliveryLeadTimeTypeNameSA;
    }

    // 取扱フラグ（とうきょう）
    if (data.HandlingFlgTK === this.FLAG_ON) {
      // 供給価格（税込）
      vo.thisTimeSupplyPriceTK = data.ThisTimeSupplyPriceTK;
      // 仕入価格
      vo.thisTimeCostPriceTK = data.ThisTimeCostPriceTK;
      // プロモーションフラグ（とうきょう）
      if (data.PromotionFlgTK === this.FLAG_ON) {
        // 成立数量
        vo.approvedNumTK = data.ApprovedNumTK;
        // 成立価格
        vo.approvedPriceTK = data.ApprovedPriceTK;
      }
      // 配達リード区分
      vo.deliveryLeadTimeTypeTK = data.DeliveryLeadTimeTypeTK;
      // 配達リード区分名称
      vo.deliveryLeadTimeTypeNameTK = data.DeliveryLeadTimeTypeNameTK;
    }

    // 取扱フラグ（ながの）
    if (data.HandlingFlgNA === this.FLAG_ON) {
      // 供給価格（税込）
      vo.thisTimeSupplyPriceNA = data.ThisTimeSupplyPriceNA;
      // 仕入価格
      vo.thisTimeCostPriceNA = data.ThisTimeCostPriceNA;
      // プロモーションフラグ（ながの）
      if (data.PromotionFlgNA === this.FLAG_ON) {
        // 成立数量
        vo.approvedNumNA = data.ApprovedNumNA;
        // 成立価格
        vo.approvedPriceNA = data.ApprovedPriceNA;
      }
      // 配達リード区分
      vo.deliveryLeadTimeTypeNA = data.DeliveryLeadTimeTypeNA;
      // 配達リード区分名称
      vo.deliveryLeadTimeTypeNameNA = data.DeliveryLeadTimeTypeNameNA;
    }

    // 取扱フラグ（にいがた）
    if (data.HandlingFlgNI === this.FLAG_ON) {
      // 供給価格（税込）
      vo.thisTimeSupplyPriceNI = data.ThisTimeSupplyPriceNI;
      // 仕入価格
      vo.thisTimeCostPriceNI = data.ThisTimeCostPriceNI;
      // プロモーションフラグ（にいがた）
      if (data.PromotionFlgNI === this.FLAG_ON) {
        // 成立数量
        vo.approvedNumNI = data.ApprovedNumNI;
        // 成立価格
        vo.approvedPriceNI = data.ApprovedPriceNI;
      }
      // 配達リード区分
      vo.deliveryLeadTimeTypeNI = data.DeliveryLeadTimeTypeNI;
      // 配達リード区分名称
      vo.deliveryLeadTimeTypeNameNI = data.DeliveryLeadTimeTypeNameNI;
    }

    // 取扱フラグ（クルコ）
    if (data.HandlingFlgKU === this.FLAG_ON) {
      // 供給価格（税込）
      vo.thisTimeSupplyPriceKU = data.ThisTimeSupplyPriceKU;
      // 仕入価格
      vo.thisTimeCostPriceKU = data.ThisTimeCostPriceKU;
      // プロモーションフラグ（クルコ）
      if (data.PromotionFlgKU === this.FLAG_ON) {
        // 成立数量
        vo.approvedNumKU = data.ApprovedNumKU;
        // 成立価格
        vo.approvedPriceKU = data.ApprovedPriceKU;
      }
      // 配達リード区分
      vo.deliveryLeadTimeTypeKU = data.DeliveryLeadTimeTypeKU;
      // 配達リード区分名称
      vo.deliveryLeadTimeTypeNameKU = data.DeliveryLeadTimeTypeNameKU;
    }

    return vo;
  }

}
